import { FC, useEffect, useState } from 'react';
import { PaymentElement, useElements } from '@stripe/react-stripe-js';
import { StripePaymentElementChangeEvent } from '@stripe/stripe-js';
import dibsCss from 'dibs-css';
import { usePaymentMethodSelectContext } from '../PaymentMethodSelectContext';
import { isStripeElementPaymentMethod } from '../../types';
import { getPaymentElementOptions } from './paymentElementOptions';

export const StripeMultiplePaymentMethod: FC = () => {
    const elements = useElements();
    const { selectedPaymentMethod, updateSelectedPaymentMethod, paymentMethods } =
        usePaymentMethodSelectContext();

    const isSelected =
        isStripeElementPaymentMethod(selectedPaymentMethod) &&
        !selectedPaymentMethod?.paymentMethodToken;

    const [isStripeElementReady, setIsStripeElementReady] = useState(false);

    useEffect(() => {
        if (!isStripeElementReady) {
            return;
        }

        if (!isSelected) {
            elements?.getElement('payment')?.collapse();
        }
    }, [elements, isSelected, isStripeElementReady]);

    function handleReady(): void {
        setIsStripeElementReady(true);
    }

    function handleChange(event: StripePaymentElementChangeEvent): void {
        // ignore change events before stripe element is ready for user interaction
        if (isStripeElementReady && !event.collapsed) {
            const paymentMethodType = paymentMethods.find(
                paymentMethod => paymentMethod.processorPaymentMethodName === event.value?.type
            )?.paymentMethodType;

            if (paymentMethodType) {
                updateSelectedPaymentMethod({
                    paymentMethodType,
                    paymentProcessor: 'STRIPE',
                });
            }
        }
    }

    return (
        <div className={isStripeElementReady ? '' : dibsCss.hidden}>
            <PaymentElement
                options={getPaymentElementOptions({ isSingleForm: false })}
                onChange={handleChange}
                onReady={handleReady}
            />
        </div>
    );
};
